// regex from W3C
// https://emailregex.com/index.html
// 驗證 Email 格式 (允許最後沒有頂級域名，例如 .com, .tw etc.)
export const regexEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// chatGPT 提供
// 驗證 Email 格式，必須要有頂級域名
// 在管理權限頁中使用，需要比較嚴格的規則，判斷是否為 Email 格式，或工號@統編
export const regexEmail2 = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

